/* Aqualumen: countdown for the Black Friday hero and band. It only counts down to real
   campaign dates set in the section settings and hides itself after the end. */
class AqCountdown extends HTMLElement {
  connectedCallback() {
    this.start = Date.parse(this.dataset.start || '');
    this.end = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.end)) {
      this.hidden = true;
      return;
    }
    this.label = this.querySelector('[data-aq-label]');
    this.units = {
      days: this.querySelector('[data-aq-days]'),
      hours: this.querySelector('[data-aq-hours]'),
      minutes: this.querySelector('[data-aq-minutes]'),
      seconds: this.querySelector('[data-aq-seconds]'),
    };
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const now = Date.now();
    const beforeStart = !Number.isNaN(this.start) && now < this.start;
    const target = beforeStart ? this.start : this.end;
    const left = target - now;

    if (left <= 0 && !beforeStart) {
      clearInterval(this.timer);
      this.hidden = true;
      // A campaign band (aq-bf-band) goes away with its countdown
      this.closest('[data-aq-campaign]')?.setAttribute('hidden', '');
      return;
    }

    if (this.label) {
      this.label.textContent = beforeStart ? this.dataset.labelBefore : this.dataset.labelDuring;
    }

    const s = Math.max(0, Math.floor(left / 1000));
    const pad = (n) => String(n).padStart(2, '0');
    this.units.days.textContent = pad(Math.floor(s / 86400));
    this.units.hours.textContent = pad(Math.floor((s % 86400) / 3600));
    this.units.minutes.textContent = pad(Math.floor((s % 3600) / 60));
    this.units.seconds.textContent = pad(s % 60);
    this.hidden = false;
  }
}

if (!customElements.get('aq-countdown')) customElements.define('aq-countdown', AqCountdown);
